import {TermFilter} from '@dofleini/query-builder';
import PropTypes from 'prop-types';
import React, {memo, useCallback, useMemo} from 'react';

import {useCrud} from '@/hooks/useCrud';
import NotariesSelect from '@/modules/configuration/components/NotariesSelect';

import {CACHE_KEY_LIST_EXPEDIENT} from '../../contants/expedient';
import ExpedientApiService from '../../services/ExpedientApiService';

const AssignNotaryOffice = ({value, entity, service = ExpedientApiService, cacheKey=CACHE_KEY_LIST_EXPEDIENT}) => {
  const {isLoading, update} = useCrud(service, cacheKey);

  const filters = useMemo(() => new TermFilter({
    field: 'address.province',
    value: entity?.address?.province
  }).toQuery(), [entity?.address?.province]);

  const handleChange = useCallback(async (notaryOffice) => {
    await update({
      _id: entity?._id,
      notaryOffice,
    });
  }, [entity, update]);

  return (
    <NotariesSelect value={value} onChange={handleChange} filters={filters} loading={isLoading}/>
  );
};

AssignNotaryOffice.propTypes = {
  value: PropTypes.any,
  service: PropTypes.any,
  cacheKey: PropTypes.string,
  entity: PropTypes.object
};

export default memo(AssignNotaryOffice);

export const renderAssignNotaryOffice = (value, entity, service, cacheKey) => <AssignNotaryOffice
  value={value}
  entity={entity}
  service={service}
  cacheKey={cacheKey}
/>;
